import React from 'react';
import { Link } from "react-router-dom";
// import { FiMapPin } from "react-icons/fi";
import { FiMail } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { FiFacebook } from "react-icons/fi";
import { FiInstagram } from "react-icons/fi";
import { FiTwitter } from "react-icons/fi";
import { FiLinkedin } from "react-icons/fi";
import { IoMdPaperPlane } from "react-icons/io";

import Company from './Menu/Company';
import Products from './Menu/Products';
import Services from './Menu/Services';
import { FaLocationPin } from 'react-icons/fa6';



export default function FooterMain() {
  const getCompanyName = () => {
    if (window.location.hostname === 'techtrenders.net' || window.location.hostname === 'www.techtrenders.net') {
      return 'Tech Trenders Software Solutions Pvt Ltd';
    } else {
      return 'Pier of Cloud Tech Inc';
    }
  }

  return (
   



<section className='footer_section'>

<div className='container'>
<div className='row'>

<div className='col-lg-2 mb-3 mb-md-0'>
<h6>Company</h6>
<Company/>


</div>

<div className='col-lg-2 mb-3 mb-md-0'>

    <h6>Services</h6>
<Services/>
</div>



<div className='col-lg-3 mb-3 mb-md-0'>

    <h6>Products</h6>
    <Products/>
</div>


<div className='col-lg-5 mb-3 mb-md-0'>

<div className='mb-4'>     
    <h6>Get In Touch</h6>
    <h6><FaLocationPin /><span className='m-1'>Want To Meet?</span></h6>
    <div className='row'>
      <div className='col-6'>
        <h6>India Office!</h6>
        <ul>
          <li><FiPhone/> +91 8520861115 </li>
          <li><FiMail/> info@techtrenders.net </li> 
        </ul>
      </div>

      <div className='col-6'>
        <h6>Canada Office!</h6>
        <ul>
          <li><FiPhone/> +1 6138848806 </li>
          <li><FiMail/> info@pierofcloudtech.com </li> 
        </ul>
      </div>
    </div>
</div>

<div className='mb-2'>     
    <h6>Newsletter</h6>
    <ul>
    <li>Don't miss to subscribe to our new feeds, kindly fill the form below. </li>

    <li> 
        
        <div className='newsletter'>

        <div className="input-group">
        <input id='newlatterinp' type='text' className='form-control' placeholder='Email Address'/>
  <div className="input-group-append">
  <button className='btn_news'><IoMdPaperPlane/> </button>
  </div>
</div>

        

      
        </div>
         </li>

    </ul>
    
</div>



</div>



</div>
</div>

<hr/>

<div className='container'>
<div className='row'>
<div className='col-lg-9'> <span className='copyright'>Copyright © {new Date().getFullYear()} {getCompanyName()}. All rights reserved.</span></div>
<div className='col-lg-3'> 

<div className='social_icons'>

<Link to='/'><FiFacebook/></Link>
<Link to='/'><FiInstagram/></Link>
<Link to='/'><FiLinkedin/></Link>
<Link to='/'><FiTwitter/></Link>
</div>

</div>

</div>
</div>

</section>


  )
}
